import Api from '../../shared/Api';
import { addISOWeekYears } from 'date-fns';

export default class PhotoOrderListApi {
    static getEditedPhotoOrders() {
        return new Api().get('/views/photo-order-list/edited');
    }
    
    static getEditedPhotoOrdersV2() {
        return new Api().get('/views/photo-order-list/edited/v2');
    }

    static getUneditedPhotoOrders(date: any) {
        return new Api().post('/views/photo-order-list/unedited', {
            browserInputDateTime: date
        });
    }

    static getImageEditors() {
        return new Api().get('/views/photo-order-list/image-editors');
    }
    static getFutureOrders() {
        return new Api().get('/views/photo-order-list/future');
    }

    static assignOrder(orderId: number, userId: number) {
        return new Api().post('/views/imageeditors/assign', {
            orderId: orderId,
            userId: userId
        });
    }

    static unAssignOrder(orderId: number) {
        return new Api().post('/views/imageeditors/unassign', {
            orderId: orderId
        });
    }
}
